// removed by extract-text-webpack-plugin
module.exports = {"header":"Header__header___34z-4","column":"Header__column___2Mj4G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/Header/Header.scss
// module id = 656
// module chunks = 0